import React from 'react';
import Input from './Input';

interface Props {
  onValueChange: (value: number) => void;
  compact?: boolean;
}

class StepperInput extends React.Component<Props> {
  private input = React.createRef<Input>();

  static defaultProps = {
    compact: false,
    onValueChange: () => {},
  };

  onInputChange = (value: string) => {
    this.props.onValueChange(Number(value));
  };

  incrementValue = () => {
    if (this.input.current) {
      this.input.current.modifyInput(value => (Number(value) + 1).toString());
    }
  };

  decrementValue = () => {
    if (this.input.current) {
      this.input.current.modifyInput(value => (Number(value) - 1).toString());
    }
  };

  renderSteppers = () => (
    <div>
      <div className="stepper-arrow" onClick={this.incrementValue}>
        <i className="icon-plus" />
      </div>
      <div className="stepper-arrow" onClick={this.decrementValue}>
        <i className="icon-minus" />
      </div>
    </div>
  );

  render() {
    const { compact, onValueChange, ...rest } = this.props;
    return (
      <Input
        ref={this.input}
        type="number"
        className="stepper"
        onValueChange={this.onInputChange}
        compact={compact}
        rightSection={this.renderSteppers()}
        {...rest}
      />
    );
  }
}

export default StepperInput;
